import { PPUIGrid } from 'pricing-pages-ui-components/grid/PPUIGrid';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { useLocation } from 'react-router-dom';
import SideNav from '../components/layout/side-nav/SideNav';
import { getNavItemForProductLine } from '../utils/routingUtils';
import { useInAppCurrencies } from './hooks/pricing/useCurrencyDetails';
import { SideNavContainer } from './side-nav/SideNavContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PageWrapper = ({
  productLine,
  navItem,
  children
}) => {
  useInAppCurrencies();
  const location = useLocation();
  const isInternalDevelopment = location.pathname.startsWith('/internal-development');
  const selectedNavItem = navItem !== null && navItem !== void 0 ? navItem : productLine ? getNavItemForProductLine(productLine) : null;
  return /*#__PURE__*/_jsxs(PPUIGrid, {
    inlineSize: "100%",
    maxInlineSize: "1528px",
    margin: "auto",
    paddingBlockStart: "400",
    paddingInline: "200",
    gridTemplateAreas: "\"side-nav content\"",
    gridTemplateColumns: "minmax(280px, auto) 1fr",
    rowGap: "400",
    children: [/*#__PURE__*/_jsx(PPUIGridItem, {
      gridArea: "side-nav",
      children: isInternalDevelopment ? /*#__PURE__*/_jsx(SideNavContainer, {}) : /*#__PURE__*/_jsx(SideNav, {
        selectedNavItem: selectedNavItem !== null && selectedNavItem !== void 0 ? selectedNavItem : 'suite'
      })
    }), /*#__PURE__*/_jsx(PPUIGridItem, {
      gridArea: "content",
      children: children
    })]
  });
};